<template>
  <header
    class="sticky top-0 flex w-full border-b bg-primary-bg  border-light-border dark:bg-primary-dark-bg text-primary-text dark:text-gray-100 dark:border-dark-border">
    <div class="flex grow flex-col items-center justify-between lg:flex-row lg:px-6">
      <div
        class="flex w-full items-center justify-between gap-2 border-b border-light-border dark:border-dark-border px-4 py-3 sm:gap-4 lg:justify-end lg:border-b-0 lg:px-0">
        <button @click="$emit('toggleSidebar')" class="lg:hidden">
          <svg v-if="!isSidebarOpen" class="w-6 h-6 text-secondary-text dark:text-gray-300" fill="none"
            stroke="currentColor" stroke-width="2" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path stroke-linecap="round" stroke-linejoin="round" d="M4 6h16M4 12h16M4 18h16"></path>
          </svg>
        </button>

        <div class="flex items-center gap-4 lg:px-0 lg:py-4 relative">
          <button @click="toggleDarkMode"
            class="flex items-center justify-center w-10 h-10 rounded-full border border-light-border dark:border-gray-600 bg-primary-bg dark:bg-gray-800 shadow-sm hover:light-hover dark:hover:bg-gray-700">
            <MoonIcon v-if="!isDarkMode" class="w-6 h-6 text-secondary-text dark:text-gray-300" />
            <SunIcon v-else class="w-6 h-6 " />
          </button>

          <!-- <button @click.stop="toggleMenu"
            class="flex items-center justify-center w-10 h-10 rounded-full border border-light-border dark:border-gray-600 bg-primary-bg dark:bg-gray-800 shadow-sm hover:light-hover dark:hover:bg-gray-700">
            <UserIcon class="w-8 h-8 text-secondary-text dark:text-gray-300" />
          </button> -->

          <!-- logout -->
          <button @click="logout"
            class="flex items-center justify-center w-10 h-10 rounded-full border border-light-border dark:border-gray-600 bg-primary-bg dark:bg-gray-800 shadow-sm hover:light-hover dark:hover:bg-gray-700">
            <ArrowRightStartOnRectangleIcon class="w-8 h-7 text-secondary-text dark:text-gray-300" />
          </button>

          <!-- <div v-if="showMenu" ref="menuRef"
            class="absolute right-0 top-full mt-2 w-48 rounded-lg border border-light-border dark:border-gray-600 bg-primary-bg dark:bg-gray-800 p-2 shadow-lg z-[99999]">
             <router-link to="/profil" @click="closeMenu"
              class="block rounded px-4 py-2 text-sm text-primary-text dark:text-gray-100  hover:light-hover dark:hover:bg-gray-700">
              Hesap Ayarları
            </router-link>
            <button
              class="w-full rounded px-4 py-2 text-left text-sm text-red-600 hover:light-hover dark:hover:bg-gray-700"
              @click="logout">
              Çıkış Yap
            </button>
          </div> -->
        </div>
      </div>
    </div>
  </header>
</template>

<script>
import { MoonIcon, SunIcon, ArrowRightStartOnRectangleIcon } from '@heroicons/vue/24/outline'
import auth from '@/stores/auth'

export default {
  name: 'AppHeader',
  components: {
    // UserIcon,
    ArrowRightStartOnRectangleIcon,
    MoonIcon,
    SunIcon,
  },
  props: {
    isSidebarOpen: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      showMenu: false,
      isDarkMode: false
    }
  },
  mounted() {
    document.addEventListener('click', this.handleClickOutside);
    const saved = localStorage.getItem('darkMode') === 'true'
    this.isDarkMode = saved
    if (saved) {
      document.documentElement.classList.add('dark')
    } else {
      document.documentElement.classList.remove('dark')
    }
  },
  beforeUnmount() {
    document.removeEventListener('click', this.handleClickOutside);
  },
  methods: {
    closeMenu() {
      this.showMenu = false;
    },
    logout() {
      this.closeMenu();
      auth.logout()
    },
    toggleMenu() {
      this.showMenu = !this.showMenu;
    },
    handleClickOutside(event) {
      if (this.showMenu) {
        const menu = this.$refs.menuRef;
        if (menu && !menu.contains(event.target)) {
          this.showMenu = false;
        }
      }
    },
    toggleDarkMode() {
      this.isDarkMode = !this.isDarkMode
      if (this.isDarkMode) {
        document.documentElement.classList.add('dark')
        localStorage.setItem('darkMode', 'true')
      } else {
        document.documentElement.classList.remove('dark')
        localStorage.setItem('darkMode', 'false')
      }
    }
  },
}
</script>
